import {Helmet} from '@dr.pogodin/react-helmet';

import {useGetDiscountApplicationMethodQuery, useGetRoundStepQuery} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {DiscountApplicationMethodForm} from './components/DiscountApplicationMethodForm';
import {getDiscountApplicationMethodDefaultValues} from './utils/getDiscountApplicationMethodDefaultValues';
import {getRoundStepOptions} from './utils/getRoundStepOptions';

export function DiscountApplicationMethod() {
  const {data: settings, isLoading, isError} = useGetDiscountApplicationMethodQuery();
  const {
    data: roundSteps,
    isLoading: isRoundStepLoading,
    isError: isRoundStepError,
  } = useGetRoundStepQuery();

  return (
    <>
      <Helmet title={i18n.t('page.accountingSettings.labels.discountApplicationMethod')} />
      <SettingsTemplate
        isLoading={isLoading || isRoundStepLoading}
        isError={isError || isRoundStepError}
        data-testid={testIds.settings.discountApplicationMethod('template')}
        header={{title: i18n.t('page.accountingSettings.labels.discountApplicationMethod')}}
      >
        <DiscountApplicationMethodForm
          defaultValues={getDiscountApplicationMethodDefaultValues(settings)}
          roundStepOptions={getRoundStepOptions(roundSteps)}
          data-testid={testIds.settings.discountApplicationMethod('form')}
        />
      </SettingsTemplate>
    </>
  );
}
